(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$stickyStateProvider','$urlRouterProvider'];

    function stateConfig($stateProvider, $stickyStateProvider, $urlRouterProvider) {
        $stateProvider
            .state('shipment-document', {
                parent: 'app',
                url: '/shipment-document?page&sort&search',
                sticky: true,
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_TUI'],
                    pageTitle: 'Shipment Documents',
                    title: 'Shipment Documents'
                },
                views: {
                    'shipment-document@': {
                        templateUrl: 'app/entities/shipment-document/shipment-document.html',
                        controller: 'ShipmentDocumentController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams','PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate','$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('shipment-document-detail', {
                parent: 'app',
                url: '/shipment-document/{id}',
                sticky: true,
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_TUI'],
                    pageTitle: 'Shipment Document Detail',
                    title: 'Shipment Document Detail'
                },
                views: {
                    'shipment-document-detail@': {
                        templateUrl: 'app/entities/shipment-document/shipment-document-detail.html',
                        controller: 'ShipmentDocumentDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate','$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams','ShipmentDocument', function($stateParams, ShipmentDocument) {
                        return ShipmentDocument.get({id: $stateParams.id}).$promise;
                    }],
                    previousState: ['$state', function($state) {
                        var currentStateData = {
                            name: $state.current.name || 'shipment-document',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('shipment-document.delete', {
                parent: 'app',
                url: '/shipment-document/{id}/delete',
                sticky: false,
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_TUI']
                },
                onEnter: ['$stateParams','$state','$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/shipment-document/shipment-document-delete-modal.html',
                        controller: 'ShipmentDocumentDeleteModalController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ShipmentDocument', function(ShipmentDocument) {
                                return ShipmentDocument.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('shipment-document', null, {reload:true});
                    }, function() {
                        $state.go('^');
                    });
                }]
            });

        $stickyStateProvider.enableDebug(true);
    }
})();
